import { IsEmail } from "@wog/mol-lib-api-contract/utils/validators";
import { HTTP_VERBS } from "../../enums";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/v3.1/email";

export class Body {
	@IsEmail({ isOptional: false })
	email!: string;
}

export class Response {}
